module.exports = __webpack_public_path__ + "img/CAPTAIN.495a8531.png";